import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useGetAmenitiesCurrency() {
    const amenities = useAppSelector((state) => (state.checkOrder.ticket.amenities))
    if (amenities) {
        const {singleRouteAmenities, returnRouteAmenities} = amenities || {}

        return singleRouteAmenities[0]?.currency ?? returnRouteAmenities[0]?.currency
    }

    return null
}